import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
const filterParent = document.getElementById('filter');

if (filterParent) {
    const filterBtnTop = document.getElementById('filter-button-top');
    const filterBtnBottom = document.getElementById('filter-button-bottom');
    const breadcrumbs = document.getElementById('breadcrumbs');

    if (filterBtnTop && filterBtnBottom) {
        addClickEvent(filterBtnTop);
        addClickEvent(filterBtnBottom);
    }

    function addClickEvent(element) {
        element.addEventListener('click', function() {
            filterParent.classList.toggle('collapsed');
            breadcrumbs.classList.toggle('collapsed');
            filterBtnTop.classList.toggle('active');
            filterBtnBottom.classList.toggle('active');

            let menu = filterParent.children[0];
            if (filterParent.classList.contains('collapsed')) {
                enableBodyScroll(menu);
            } else {
                disableBodyScroll(menu, {
                    reserveScrollBarGap: true
                });
            }
        });
    }
}
